import { StyleSheet, View } from 'react-native';

import { classifyPaymentMethods } from 'components/payment-method/utils';
import { ActionButton } from 'components/ui/action-button';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import { PaymentMethodDetails } from '../payment-method-details';
import { PaymentMethodIcon } from '../payment-method-icon';

import { SelectorProps } from './types';

export type SelectorSelectionProps = SelectorProps & {
  onChange?: () => void;
  isDisabled?: boolean;
};

export function SelectorSelection({
  methods,
  selectedMethodId = '',
  onChange,
  isDisabled,
}: SelectorSelectionProps) {
  const { selectedMethod } = classifyPaymentMethods(methods, selectedMethodId);

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <PaymentMethodIcon paymentMethod={selectedMethod} size="lg" bordered />
        <PaymentMethodDetails paymentMethod={selectedMethod} />
      </View>
      <ActionButton testID="change-btn" width="auto" onPress={onChange} disabled={isDisabled}>
        {t('change')}
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    gap: primitive.spacing.$4,
  },
});
